import { __extends } from "tslib";
import React from "react";
import { MenuItem, SplitButton } from "react-bootstrap";
var SplitButtonDropDown = (function (_super) {
    __extends(SplitButtonDropDown, _super);
    function SplitButtonDropDown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderOptions = function () {
            var options = _this.props.options;
            if (!options || options.size < 1) {
                return null;
            }
            var items = [];
            options.forEach(function (label, value) {
                items.push(React.createElement(MenuItem, { key: value, eventKey: value, onSelect: function () { return _this.onSelect(value); } }, label));
            });
            return items;
        };
        _this.onSelect = function (option) {
            var onSelect = _this.props.onSelect;
            onSelect(option);
        };
        return _this;
    }
    SplitButtonDropDown.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, value = _a.value, classNames = _a.classNames, options = _a.options;
        var title = options && options.get(value);
        return (React.createElement("div", { className: "rb-split-btn" },
            React.createElement(SplitButton, { id: id, title: title, className: classNames, onClick: function () { return _this.onSelect(value); } }, this.renderOptions())));
    };
    return SplitButtonDropDown;
}(React.PureComponent));
export { SplitButtonDropDown };
